import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as Groups from 'groups/components';
import GroupsListHandlers from 'groups/containers/GroupsListHandlers';
import GroupsRowContainer from 'groups/containers/GroupsRowContainer';

import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';
import {
  getPagination,
  getFilters,
  getVisibleGroups,
  getIsLoading,
  getNeedFetch,
} from 'groups/selectors';
import { toggleGroup } from 'groups/actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';

class GroupsListContainer extends PureComponent {
  static propTypes = {
    company: PropTypes.object.isRequired,
    subcompany: PropTypes.object.isRequired,
    pagination: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
  };
  handleToggle = (id) =>
    this.props
      .toggleGroup(id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));

  render = () => (
    <GroupsListHandlers
      render={({
        handleOrderChange,
        handleLimitChange,
        handlePageChange,
        handleFiltersChange,
        handleSubmit,
        columnSearch, // Cambiar por redux
        handleToggleSearch, // Agregar
      }) => (
        <Groups.ListView
          count={this.props.groups.length}
          filters={this.props.filters}
          company={this.props.company}
          isLoading={this.props.isLoading}
          handleToggle={this.handleToggle}
          handleOrderChange={handleOrderChange}
          handleSubmit={handleSubmit}
          handleFiltersChange={handleFiltersChange}
          handleLimitChange={handleLimitChange}
          handlePageChange={handlePageChange}
          handleToggleSearch={handleToggleSearch} // Agregar
          columnSearch={columnSearch} // Agregar - corregir por Redux
          subcompany={this.props.subcompany}
          pagination={this.props.pagination}
          permissions={this.props.permissions}
        >
          {this.props.groups.map((group) => (
            <GroupsRowContainer key={group.id} group={group} handleToggle={this.handleToggle} />
          ))}
        </Groups.ListView>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  pagination: getPagination(state),
  filters: getFilters(state),
  groups: getVisibleGroups(state),
  permissions: getPermissions(state),
  isLoading: getIsLoading(state),
  needFetch: getNeedFetch(state),
});
const mapDispatchToProps = { toggleGroup, error, success };

export default connect(mapStateToProps, mapDispatchToProps)(GroupsListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/containers/GroupsListContainer.js